export enum TravelInformationField {
  TravelDaysPerMonth = 'travelDaysPerMonth',
  parkingFeeSekPerDay = 'parkingFeeSekPerDay',
  CongestionTaxSekPerMonth = 'congestionTaxSekPerDay',
  DistanceFromHomeToWorkKmState = 'distanceFromHomeToWorkKmState',
  PrefferredTicketType = 'prefferredTicketType',
  TravelZones = 'travelZones',
  TravelDeductionSekPerYear = 'travelDeductionSekPerYear',
}
